import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import axios from "axios";
import base_url from "../../api/bootapi";
import { useForm } from "react-hook-form";
import Modal from "react-bootstrap/Modal";
import Cards from "react-credit-cards";

const CreditCardUpdateForm = () => {
  const { search } = useLocation();
  const queryparam = queryString.parse(search);

  //------------------->Boolean States
  const [loader, setloader] = useState(false);
  const [showimeiui, setshowimeiui] = useState(false);
  const [carderror, setcarderror] = useState(false);
  const [error, seterror] = useState(false);
  const [success, setsuccess] = useState(false);
  const [showsuccessmodal, setshowsuccessmodal] = useState(false);

  //------------------------>Data storing states
  const [cardnumber, setcardnumber] = useState("");
  const [newcardnumber, setnewcardnumber] = useState("");
  const [cardyear, setcardyear] = useState("");
  const [cardmonth, setcardmonth] = useState("");
  const [expiry, setexpiry] = useState("");
  const [cardholdername, setcardholdername] = useState("");
  const [cvc, setcvc] = useState("");
  const [focus, setfocus] = useState();
  const [carduserdetails, setcarduserdetails] = useState();
  const [datearray, setdatearray] = useState([]);
  const [montharray, setmontharray] = useState([]);
  const [companyname, setcompanyname] = useState("");
  const [message, setmessage] = useState();

  //------------------------->Storing position of div ref
  const messagesEndRef = useRef(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  useEffect(() => {
    /* eslint-disable react-hooks/exhaustive-deps */
    addyears();
  }, []);
  const addyears = () => {
    let date2 = new Date();
    let arr = [date2.getFullYear()];
    for (let i = 1; i <= 16; i++) {
      let date = new Date();
      let adddata = date.getFullYear() + i;
      arr.push(adddata);
    }
    let month = Array.from(Array(12), (val, index) => index + 1);
    month.forEach((item) => {
      let appendedvalue = String(item).padStart(2, "0");
      setmontharray((prev) => [...prev, appendedvalue]);
    });
    setdatearray(arr);
  };

  const inputEvent = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setcarduserdetails((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const checkcardnumber = (val) => {
    setcardnumber(val);
    if (Number(val) && val.toString().length > 5) {
      setloader(true);
      axios
        .get(`${base_url}/info/card/validate/${queryparam?.customer_id}/${val}`)
        .then((res) => {
          setcarduserdetails(res.data.response);
          let name =
            res.data.response.first_name + " " + res.data.response.last_name;
          setcardholdername(name);
          setloader(false);
          setcarderror(false);
          setshowimeiui(true);
        })
        .catch((err) => {
          // setmovetonextui(false);
          setloader(false);
          setcarderror(true);
        });
    }
  };

  const onyearChange = (e) => {
    setmontharray([]);
    if (Number(e.target.value) === Number(new Date().getFullYear())) {
      let monthnumber = new Date().getMonth();
      let month = Array.from(
        Array(12 - monthnumber),
        (val, index) => monthnumber + index + 1
      );
      month.forEach((item) => {
        let appendedvalue = String(item).padStart(2, "0");
        setmontharray((prev) => [...prev, appendedvalue]);
      });
      if (Number(cardmonth) < Number(monthnumber + 1)) {
        setcardmonth("");
      }
    } else {
      let month = Array.from(Array(12), (val, index) => index + 1);
      month.forEach((item) => {
        let appendedvalue = String(item).padStart(2, "0");
        setmontharray((prev) => [...prev, appendedvalue]);
      });
    }
  };
  const updatecreditcard = (data2) => {
    if (!cardmonth) {
      return;
    }
    setloader(true);
    let data = {
      credit_card: {
        cardholder_name: cardholdername,
        cvv: data2.cvc,
        expiration_date: `${cardmonth}/${cardyear}`,
        number: data2.cardnumber,
      },
      customer_id: queryparam?.customer_id,
    };
    axios
      .post(`${base_url}/auth/credit-card/update`, data)
      .then((res) => {
        setloader(false);
        if (res.data.status) {
          setsuccess(true);
          seterror(false);
          setshowsuccessmodal(true);
        } else {
          let error = res.data.message;
          if (res.data.error) error = error + " : " + res.data.error;
          setmessage(error);
          setsuccess(false);
          seterror(true);
          scrollToBottom();
        }
      })
      .catch((err) => {
        if (err.response) {
          let error = err.response.data?.message;
          if (err.response.data?.error) {
            error = error + " : " + err.response.data?.error;
          }
          setmessage(error);
        } else {
          setmessage("Something Went Wrong");
        }
        setsuccess(false);
        seterror(true);
        setloader(false);
        scrollToBottom();
      });
  };
  const handleCloseModal = () => {
    setshowsuccessmodal(false);
    setsuccess(true);
    scrollToBottom();
  };
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <form id="myForm" onSubmit={handleSubmit(updatecreditcard)}>
      <div>
        <p style={{ color: "#f00" }}>
          <strong>
            NB: If your subscription is already cancelled,update your payment
            details wont activate your subscription.
            <a
              href={`https://amcrestgps.net/gps-activation/#/reactivation?customer_id=${queryparam.customer_id}`}
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: "none" }}
            >
              {" "}
              You have to reactivate the device using this link.
            </a>
          </strong>
        </p>
        <h4 className="cancellationobd_h4">Update payment details</h4>
        {loader ? (
          <img width={300} alt="loader" src="./loading.gif" />
        ) : (
          <>
            {!showimeiui ? (
              <>
                <p className="m-0 text-left">
                  Please enter the first six digits of the current credit card
                  associated with your account.
                </p>
                <p
                  style={{
                    color: "rgb(255, 0, 0)",
                    fontSize: "13px",
                  }}
                  className="text-left font-weight-bold"
                >
                  *You will get first 6 digit of your old card in my account
                  -&gt; transaction history page.
                </p>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-6">
                      <input
                        value={cardnumber}
                        onChange={(e) => checkcardnumber(e.target.value)}
                        className="form-control"
                        placeholder="first 6 digit of Card No."
                      />
                    </div>

                    <div className="col-md-6">{null}</div>
                  </div>
                  {carderror && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      Card Number doesn't match, please try with valid number.
                    </span>
                  )}
                </div>
              </>
            ) : (
              <>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-6">
                      <input
                        {...register("first_name", { required: true })}
                        value={carduserdetails?.first_name}
                        onChange={inputEvent}
                        placeholder="First Name"
                        className="form-control"
                      />
                      {errors.first_name && (
                        <span className="errormessage">
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          FirstName is required
                        </span>
                      )}
                    </div>
                    <div className="col-md-6">
                      <input
                        type="text"
                        {...register("last_name", { required: true })}
                        value={carduserdetails?.last_name}
                        onChange={inputEvent}
                        placeholder="Last Name"
                        className="form-control"
                      />
                      {errors.last_name && (
                        <span className="errormessage">
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          LastName is required
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-12">
                      <input
                        className="form-control"
                        value={companyname}
                        onChange={(e) => setcompanyname(e.target.value)}
                        placeholder="Company Name"
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-12">
                      <input
                        {...register("billing_address", { required: true })}
                        value={carduserdetails?.billing_address}
                        onChange={inputEvent}
                        className="form-control"
                        placeholder="Billing Address"
                      />
                      {errors.billing_address && (
                        <span className="errormessage">
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          Billing Address is required
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <Cards
                    number={newcardnumber}
                    name={cardholdername}
                    expiry={expiry}
                    cvc={cvc}
                    focused={focus}
                  />
                </div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-12">
                      <input
                        type="text"
                        {...register("cardholdername", { required: true })}
                        value={cardholdername}
                        onChange={(e) => setcardholdername(e.target.value)}
                        className="form-control"
                        placeholder="Card Holder Name"
                        onFocus={(e) => setfocus(e.target.name)}
                      />
                      {errors.cardholdername && (
                        <span className="errormessage">
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          Card Holder Name is required
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-9">
                      <input
                        {...register("cardnumber", {
                          required: true,
                          maxLength: 20,
                          minLength: 15,
                        })}
                        type="number"
                        onWheel={(event) => event.currentTarget.blur()}
                        className="form-control"
                        placeholder="Card Number"
                        onChange={(e) => setnewcardnumber(e.target.value)}
                        onFocus={(e) => setfocus(e.target.name)}
                      />
                      <p
                        className="marginp text-left"
                        style={{ fontSize: "15px" }}
                      >
                        **** **** **** {carduserdetails?.last4}
                      </p>
                      {errors.cardnumber?.type === "required" && (
                        <span className="errormessage">
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          CardNumber is required
                        </span>
                      )}
                      {errors.cardnumber?.type === "minLength" && (
                        <span className="errormessage">
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          CardNumber should be minimum of 15 numbers
                        </span>
                      )}
                      {errors.cardnumber?.type === "maxLength" && (
                        <span
                          className="errormessage"
                          style={{ fontSize: "15px" }}
                        >
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          CardNumber cannot exceed more than 20 numbers
                        </span>
                      )}
                    </div>
                    <div className="col-md-3">
                      <input
                        {...register("cvc", {
                          required: true,
                          minLength: 3,
                          maxLength: 4,
                        })}
                        type="number"
                        onWheel={(event) => event.currentTarget.blur()}
                        className="form-control"
                        placeholder="CVV"
                        onChange={(e) => setcvc(e.target.value)}
                        onFocus={(e) => setfocus(e.target.name)}
                      />
                      {errors.cvc?.type === "required" && (
                        <span
                          className="errormessage"
                          style={{ fontSize: "14px" }}
                        >
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          CVV is required
                        </span>
                      )}
                      {errors.cvc?.type === "minLength" && (
                        <span
                          className="errormessage"
                          style={{ fontSize: "14px" }}
                        >
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          CVV should be minimum of 3 numbers
                        </span>
                      )}
                      {errors.cvc?.type === "maxLength" && (
                        <span
                          className="errormessage"
                          style={{ fontSize: "14px" }}
                        >
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          CVV cannot be more than 4 numbers
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label style={{ display: "flex" }}>Expiration Date</label>
                  <div className="row">
                    <div className="col-md-6">
                      <select
                        {...register("expirationdatemonth", { required: true })}
                        value={cardmonth}
                        onChange={(e) => {
                          setcardmonth(e.target.value);
                          setexpiry(`${e.target.value}/${cardyear}`);
                        }}
                        className="form-control"
                        onFocus={(e) => setfocus(e.target.name)}
                      >
                        <option value="">MM</option>
                        {montharray?.map((item, index) => (
                          <option key={index + 1} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                      {errors.expirationdatemonth && (
                        <span className="errormessage">
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          Month is required
                        </span>
                      )}
                    </div>
                    <div className="col-md-6">
                      <select
                        value={cardyear}
                        {...register("expirationdateyear", { required: true })}
                        onChange={(e) => {
                          setcardyear(e.target.value);
                          onyearChange(e);
                          setexpiry(`${cardmonth}/${e.target.value}`);
                        }}
                        className="form-control"
                        onFocus={(e) => setfocus(e.target.name)}
                      >
                        <option value="">YYYY</option>
                        {datearray?.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                      {errors.expirationdateyear && (
                        <span className="errormessage">
                          <span>
                            <i
                              className="fa fa-times errorifont"
                              aria-hidden="true"
                            ></i>
                          </span>
                          Year is required
                        </span>
                      )}
                    </div>
                  </div>
                  {error ? (
                    <div>
                      <div className="alert alert-danger">
                        <strong>Error! </strong>
                        {message}
                      </div>
                    </div>
                  ) : null}
                  <div ref={messagesEndRef} />
                  {success ? (
                    <div>
                      <div className="alert alert-success">
                        <strong>Success! </strong>
                        Credit Card Updated Successfully
                      </div>
                      <div className="alert alert-success">
                        <strong>
                          "If your subscription is already cancelled, you have
                          to reactivate."
                          <a
                            href={`https://amcrestgps.net/gps-activation/#/reactivation?customer_id=${queryparam.customer_id}`}
                            target="_blank"
                            rel="noreferrer"
                            style={{ textDecoration: "none" }}
                          >
                            Click Here
                          </a>{" "}
                        </strong>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="activation"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div></div>
                      <button className={"btn btn-primary"} type="submit">
                        Update
                      </button>
                    </div>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>
      <Modal
        size="md"
        show={showsuccessmodal}
        onHide={() => handleCloseModal()}
        backdrop="static"
      >
        <Modal.Header closeButton={() => handleCloseModal()}>
          <Modal.Title style={{ color: "#3947e6" }}>Success!!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4 className="form-main" style={{ color: "#3947e6" }}>
            Credit Card Updated Successfully
          </h4>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => handleCloseModal()}
            type="button"
            className="btn btn-primary"
          >
            Ok
          </button>
        </Modal.Footer>
      </Modal>
    </form>
  );
};

export default CreditCardUpdateForm;
